import _ from 'underscore';
import { reload } from '../../validation/validation-controller';
import { get as t } from '../../../home24/core/translation';
import { register } from '../../core/bootstrapper';
import CartView from '../cart/cartView';
import * as registry from '../../../home24/core/registry';
import CheckoutAddressModel from './checkoutAddressModel';
import CheckoutAddressView from './checkoutAddressView';
import IndexView from './indexView';
import PaymentCreditCardView from './paymentCreditCardView';
import PaymentInstallmentModel from './paymentInstallmentModel';
import PaymentInstallmentView from './paymentInstallmentView';
import PaymentInstallmentAfterPayView from './paymentInstallmentAfterPayView';
import PaymentModel from './paymentModel';
import PaymentPostfinanceView from './paymentPostfinanceView';
import PaymentValidationView from './paymentValidationView';
import PaymentView from './paymentView';
import StickyBottomView from '../../layout/stickyBottomView';

import AppDomain from '../../../home24-shared/core/AppDomain';

let paymentModel;
let installmentModel;

/*
 Payment index specific content
 */
register('checkout-index', function() {
  new CartView({
    el: $('#checkout-main')
  });

  new IndexView({
    el: $('.checkout-index-page')
  });

  var $takeOrderBox = $('#CheckoutTakeOrderBox');

  if ($takeOrderBox.length > 0) {
    new StickyBottomView({
      el: $takeOrderBox
    });
  }
});

var PAYONE_ERROR_ATTRIBUTE = 'data-payone-error-id';

var PAYMENT_METHODS = {
  CREDITCARD: 'CREDITCARD',
  MISTERCASH: 'MISTERCASH'
};

var PAYONE_SELECTORS = {
  CREDITCARD: {
    cardtype: 'creditcard_cardtype_field',
    cardpan: 'creditcard_cardpan',
    cardcvc2: 'creditcard_cardcvc2',
    cardexpiremonth: 'creditcard_cardexpiremonth',
    cardexpireyear: 'creditcard_cardexpireyear'
  },
  MISTERCASH: {
    cardtype: 'mistercash_cardtype_field',
    cardpan: 'mistercash_cardpan',
    cardexpiremonth: 'mistercash_cardexpiremonth',
    cardexpireyear: 'mistercash_cardexpireyear'
  }
};

function clearForm(paymentMethodName) {
  var selectors = PAYONE_SELECTORS[paymentMethodName] || {};

  _.each(selectors, function(selector) {
    $('#' + selector).empty();
  });
}

function _getCreditCardBaseInputStyle() {
  if (AppDomain.isFashionForHome()) {
    return 'border: 1px solid #bec4c4;margin: 0;font-family: Arial, Helvetica, sans-serif;font-size: 14px;color: #2c3638;-webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box;-webkit-border-radius: 0;-moz-border-radius: 0;-ms-border-radius: 0;-o-border-radius: 0;border-radius: 0;display: block;padding: 0 10px;line-height: 38px;line-height: 1em;height: 38px;width: 100%;-webkit-appearance: none;';
  }

  return 'border: 1px solid #bec4c4;margin: 0;font-family: Arial, Helvetica, sans-serif;font-size: 14px;color: #2c3638;-webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box;-webkit-border-radius: 3px;-moz-border-radius: 3px;-ms-border-radius: 3px;-o-border-radius: 3px;border-radius: 3px;display: block;padding: 0 10px;line-height: 38px;line-height: 1em;height: 38px;width: 100%;-webkit-appearance: none;';
}

/**
 * Returns description, for select element, based on current theme.
 *
 * @param {Object} options
 * @returns {String}
 */
function getSelectStyle(options = {}) {
  const { width = '100%' } = options;

  if (AppDomain.isFashionForHome()) {
    // NOTE this one will have no flat border due limitations on the iFrame.
    return `height: 38px; width: ${width}; padding-left: 6px; padding-right: 6px; font-size: 14px; font-family: "proxima-nova", Arial; color: #2c3638; background-color: #fff; border: 1px solid #565d60; border-radius: 0; outline: none; -webkit-transition: all .2s ease-in-out; transition: all .2s ease-in-out;`;
  }

  return `border: 1px solid #bec4c4;margin: 0;font-family: Arial,Helvetica,sans-serif;font-size: 14px;color: #2c3638;-webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box;-webkit-border-radius: 3px;-moz-border-radius: 3px;-ms-border-radius: 3px;-o-border-radius: 3px;border-radius: 3px;background-color: #fff;padding: 5px;line-height: 34px;height: 34px;width: ${width};display: block;padding: 0 0 0 5px;line-height: 38px;line-height: 1em;height: 38px;`;
}

function initCreditcardForm(language) {
  var $paymentForm = $('.payment');
  var iframes;
  var payoneSettings = registry.get('PayoneSettings') || {};
  var requestSettings = payoneSettings.request;
  var availableCardTypes = getCardTypes(PAYMENT_METHODS.CREDITCARD);

  var fieldsConfig = {
    fields: {
      cardtype: {
        selector: PAYONE_SELECTORS.CREDITCARD.cardtype,
        cardtypes: availableCardTypes,
        style: getSelectStyle({ width: '100%' })
      },
      cardpan: {
        selector: PAYONE_SELECTORS.CREDITCARD.cardpan,
        type: 'text',
        iframe: {
          width: '100%'
        }
      },
      cardcvc2: {
        selector: PAYONE_SELECTORS.CREDITCARD.cardcvc2,
        type: 'password',
        size: '4',
        maxlength: '4'
      },
      cardexpiremonth: {
        selector: PAYONE_SELECTORS.CREDITCARD.cardexpiremonth,
        type: 'select',
        size: '2',
        maxlength: '2',
        iframe: {
          width: '50%'
        }
      },
      cardexpireyear: {
        selector: PAYONE_SELECTORS.CREDITCARD.cardexpireyear,
        type: 'select',
        iframe: {
          width: '50%'
        }
      }
    },
    defaultStyle: {
      input: _getCreditCardBaseInputStyle(),
      select: getSelectStyle({ width: '95%' }),
      iframe: {
        height: '38px',
        width: '100%'
      }
    },
    language: window.Payone.ClientApi.Language[language]
  };

  clearForm(PAYMENT_METHODS.CREDITCARD);

  iframes = new window.Payone.ClientApi.HostedIFrames(
    fieldsConfig,
    requestSettings
  );

  $paymentForm.on('submit', function() {
    var isCreditcardSelected =
      paymentModel.get('paymentMethod') === PAYMENT_METHODS.CREDITCARD;
    var isCreditcardFormVisible = paymentModel.get('creditCardFormVisible');

    if (!(isCreditcardSelected && isCreditcardFormVisible)) return true;

    if (iframes.isComplete() && $paymentForm.valid()) {
      $paymentForm.find('button[type="submit"]').prop('disabled', true);
      clearFormError();
      iframes.creditCardCheck('checkCreditCardCallback');
    } else {
      showEmptyFormError();
    }

    return false;
  });

  window.checkCreditCardCallback = function(response) {
    $paymentForm.find('button[type="submit"]').prop('disabled', false);
    if (response.status === 'VALID') {
      $('#creditcard_pseudocardpan').val(response.pseudocardpan);
      $('#creditcard_truncatedcardpan').val(response.truncatedcardpan);
      $('#creditcard_cardexpiredate').val(response.cardexpiredate);
      $('#creditcard_cardtype').val(response.cardtype);

      $paymentForm.off('submit');
      $paymentForm.submit();
    } else {
      showFormError(response.errormessage, response.errorcode);
    }
  };
}

function initMisterCashForm(language) {
  var $paymentForm = $('.payment');
  var iframes;
  var payoneSettings = registry.get('PayoneSettings') || {};
  var requestSettings = payoneSettings.request;
  var availableCardTypes = getCardTypes(PAYMENT_METHODS.MISTERCASH);

  var fieldsConfig = {
    fields: {
      cardtype: {
        cardtypes: availableCardTypes,
        selector: PAYONE_SELECTORS.MISTERCASH.cardtype,
        iframe: {
          width: '1px',
          height: '1px'
        }
      },
      cardpan: {
        selector: PAYONE_SELECTORS.MISTERCASH.cardpan,
        type: 'text',
        iframe: {
          width: '100%'
        }
      },
      cardexpiremonth: {
        selector: PAYONE_SELECTORS.MISTERCASH.cardexpiremonth,
        type: 'select',
        size: '2',
        maxlength: '2',
        iframe: {
          width: '60px'
        }
      },
      cardexpireyear: {
        selector: PAYONE_SELECTORS.MISTERCASH.cardexpireyear,
        type: 'select',
        iframe: {
          width: '100px'
        }
      }
    },
    defaultStyle: {
      input:
        'border: 1px solid #bec4c4;margin: 0;font-family: Arial, Helvetica, sans-serif;font-size: 14px;color: #2c3638;-webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box;-webkit-border-radius: 3px;-moz-border-radius: 3px;-ms-border-radius: 3px;-o-border-radius: 3px;border-radius: 3px;display: block;padding: 0 10px;line-height: 38px;line-height: 1em;height: 38px;width: 100%;-webkit-appearance: none;',
      select: getSelectStyle({ width: '95%' }),
      iframe: {
        height: '38px',
        width: '100%'
      }
    },
    language: window.Payone.ClientApi.Language[language]
  };

  clearForm(PAYMENT_METHODS.MISTERCASH);

  iframes = new window.Payone.ClientApi.HostedIFrames(
    fieldsConfig,
    requestSettings
  );

  $paymentForm.on('submit', function() {
    var isMisterCashSelected =
      paymentModel.get('paymentMethod') === PAYMENT_METHODS.MISTERCASH;

    if (!isMisterCashSelected) return true;

    if (iframes.isComplete()) {
      $paymentForm.find('button[type="submit"]').prop('disabled', true);
      clearFormError();
      iframes.creditCardCheck('checkMistercashCallback');
    } else {
      showEmptyFormError();
    }

    return false;
  });

  window.checkMistercashCallback = function(response) {
    $paymentForm.find('button[type="submit"]').prop('disabled', false);
    if (response.status === 'VALID') {
      $('#mistercash_pseudocardpan').val(response.pseudocardpan);
      $('#mistercash_truncatedcardpan').val(response.truncatedcardpan);
      $('#mistercash_cardexpiredate').val(response.cardexpiredate);
      $('#mistercash_cardtype').val(response.cardtype);

      $paymentForm.off('submit');
      $paymentForm.submit();
    } else {
      showFormError(response.errormessage, response.errorcode);
    }
  };
}

function setPayoneTranslations(language) {
  window.Payone.ClientApi.Language[language].placeholders = {
    cardpan: t('ui.checkout.cardNumber'),
    cvc: t('ui.checkout.securityCode'),
    expireMonth: t('ui.checkout.expirationMonth'),
    expireYear: t('ui.checkout.expirationYear')
  };
}

function getCardTypes(paymentMethodName) {
  var payoneSettings = registry.get('PayoneSettings');

  try {
    return payoneSettings.config[paymentMethodName].cardtypes;
  } catch (e) {
    throw new Error(
      'Card types for ' + paymentMethodName + 'payment method is not configured'
    );
  }
}

function showFormError(errorMessage, errorId) {
  var $errorOutput = $('#errorOutput');

  clearFormError();

  if (errorId) {
    $errorOutput.attr(PAYONE_ERROR_ATTRIBUTE, errorId);
  }

  $errorOutput.html(errorMessage);
  $(window).scrollTop($errorOutput.offset().top);
}

function showEmptyFormError() {
  showFormError(t('ui.checkout.error.general'));
}

function clearFormError() {
  var $errorOutput = $('#errorOutput');

  $errorOutput.html('');
  $errorOutput.removeAttr(PAYONE_ERROR_ATTRIBUTE);
}

/*
 Payment page specific content
 */
register('checkout-payment', function() {
  var pageLanguage = $('html')
    .attr('lang')
    .match(/(\w+)-/)[1];

  var $creditCardContainer = $('.payment-creditcard');
  var $postFinanceContainer = $('.js-payment-postfinance');
  var $installmentContainer = $('.payment-installment-purchase');
  var $installmentAfterPayContainer = $('.payment-installment-afterpay');
  var $paymentForm = $('.payment');

  paymentModel = new PaymentModel({
    creditCardInfo: registry.get('creditCardInfo')
  });

  if (typeof window.Payone !== 'undefined') {
    setPayoneTranslations(pageLanguage);

    paymentModel.on('change:paymentMethod', function(model, value) {
      clearFormError();
      $paymentForm.find('button[type="submit"]').prop('disabled', false);

      if (value === PAYMENT_METHODS.CREDITCARD) {
        initCreditcardForm(pageLanguage);
      } else if (value === PAYMENT_METHODS.MISTERCASH) {
        initMisterCashForm(pageLanguage);
      }
    });
  }

  new PaymentView({
    el: $('.checkout-payment-page'),
    model: paymentModel
  });

  if ($creditCardContainer.length > 0) {
    new PaymentCreditCardView({
      el: $creditCardContainer,
      model: paymentModel
    });
  }

  if ($postFinanceContainer.length > 0) {
    new PaymentPostfinanceView({
      el: $postFinanceContainer,
      model: paymentModel
    });
  }

  if ($installmentContainer.length > 0) {
    installmentModel = new PaymentInstallmentModel({
      installmentCalculations: registry.get('installmentPurchaseCalculation')
    });

    new PaymentInstallmentView({
      el: $installmentContainer,
      model: installmentModel
    });
  }

  if ($installmentAfterPayContainer.length > 0) {
    new PaymentInstallmentAfterPayView({
      el: $installmentAfterPayContainer,
      model: paymentModel
    });
  }

  new PaymentValidationView({
    el: $paymentForm,
    model: paymentModel
  });

  var $takeOrderBox = $('#CheckoutTakeOrderBox');
  if ($takeOrderBox.length > 0) {
    new StickyBottomView({
      el: $takeOrderBox
    });
  }
});

register('checkout-address', function() {
  new CheckoutAddressView({
    el: $('.myaccount-address'),
    model: new CheckoutAddressModel()
  });

  var $takeOrderBox = $('#CheckoutTakeOrderBox');
  if ($takeOrderBox.length > 0) {
    new StickyBottomView({
      el: $takeOrderBox
    });
  }

  reload();
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/checkout/checkoutBootstrap.js
 **/